import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { CreateFormData, post } from '../../Helpers/Api'
import useLocalStorage from '../../Helpers/Hooks/useLocalStorage'
import Email from './Inputs/Email'
import Password from './Inputs/Password'

export default function Login () {
  const [, setToken] = useLocalStorage('Token', '')

  // States
  const { handleSubmit, register, formState: errors, control } = useForm()
  const formFunctions = { register, errors }
  const [Error, setError] = useState('')

  // Enviar datos a backend
  function onSubmit (body) {
    if (body.email && body.password && body.email === 'testUser@perfectrenter.com' && body.password === 'testPass123') {
      setToken('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c')
      window.location.reload()
    } else {
      setError('Usuario o contraseña incorrectos')
    }
    post(
      'http://192.168.5.103:4000/users/login',
      CreateFormData(body),
      (data) => {
        setToken(data.token)
        window.location.reload()
      },
      (data) => {
        setError(data.message)
      }
    )
  }

  return (
    <>
      <section className='flex flex-col items-center h-full gap-5 p-0 pt-24 m-0 bg-white bg-opacity-50 text-principal-gris'>
        <div className='flex justify-center w-3/6 p-4 text-3xl select-none title'>
          <h2 className='w-3/4 pb-2 text-center border-b-4 border-gray-600'>
            ACCESO
          </h2>
        </div>
        <form
          className='flex flex-col w-3/4 gap-3 sm:w-96'
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            name='email'
            control={control}
            rules={{
              required: 'Debes escribir un email.',
              maxLength: {
                value: 200,
                message: 'El email no puede contener más de 200 caracteres.'
              }
            }}
            render={({ field: { onChange, name, ref } }) => {
              return (
                <Email
                  onChange={onChange}
                  inputRef={ref}
                  name={name}
                  className='relative w-full px-3 py-3 text-sm text-gray-600 placeholder-gray-400 bg-white border border-gray-400 outline-none cursor-pointer focus:outline-none focus:ring'
                />
              )
            }}
          />
          {errors.email && (
            <p className='text-red-500'>{errors.email.message}</p>
          )}
          <Password {...formFunctions} />
          {errors.password && (
            <p className='text-red-500'>{errors.password.message}</p>
          )}
          {Error
            ? (
              <div className='font-medium text-center text-red-500'>{Error}</div>
              )
            : (
                ''
              )}
          <input
            className='self-center w-full px-3 py-2 text-center text-black duration-200 ease-in transform border border-yellow-300 cursor-pointer select-none bg-principal-1 text-principal-gris hover:bg-gray-Primary hover:text-principal-1'
            type='submit'
            value='Entrar'
          />
        </form>
        <div className='text-gray-400'>Email: testUser@perfectrenter.com</div>
        <div className='text-gray-400'>Password: testPass123</div>
        <Link
          className='p-4 font-medium duration-200 hover:text-blue-900 hover:underline'
          to='/recuperar'
        >
          Recuperar contraseña
        </Link>
        <div className='flex gap-1'>
          ¿Aún no tienes cuenta? RegÍstrate
          <Link
            className='font-medium duration-200 hover:text-blue-900 hover:underline'
            to='/registro'
          >
            aquí
          </Link>
        </div>
      </section>
    </>
  )
}
